import cn from 'classnames';
import { LoaderButton } from 'components/Button';
import styles from './loadMore.scss';
import { useDispatch } from 'react-redux';
import { GtmViewMoreProducts } from 'store/googleTagManager/actions';

interface LoadMoreProps {
  loadMoreButtonText: string;
  className?: string;
  showMoreProducts: () => Promise<void>;
  nextPageUrl?: string;
}

export const LoadMore = ({
  className,
  showMoreProducts,
  nextPageUrl,
  loadMoreButtonText
}: LoadMoreProps) => {
  const dispatch = useDispatch();
  const decoratedShowMoreProducts = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.currentTarget.blur();
    dispatch(GtmViewMoreProducts());
    return showMoreProducts();
  };

  return (
    <LoaderButton
      href={nextPageUrl}
      appearance="tertiary"
      border="thin"
      className={cn(className, styles.loadMore)}
      onClick={decoratedShowMoreProducts}
    >
      {loadMoreButtonText}
    </LoaderButton>
  );
};
